export const education = [
  {
    eduDate: "2019-2023",
    eduTitle: "Zonguldak Bulent Ecevit University",
    eduIns: "Computer Engineering",
    eduDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
];
